import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { indexOf, without } from 'lodash';
import Fa from 'react-fontawesome';
import { FormGroup, HelpBlock } from 'react-bootstrap';
import { Field } from 'redux-form';
import masterField from '../../../../components/search-form/master-field';

class OpportunityStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.handleClick = this.handleClick.bind(this);
    this.renderField = this.renderField.bind(this);
  }

  handleClick(name, val) {
    const { disabled, value } = this.props;
    if (!disabled) {
      let newValues = [...value];
      if (indexOf(newValues, val) >= 0) {
        newValues = without(newValues, val);
      } else {
        newValues.push(val);
      }
      this.props.onChange(name, newValues);
    }
  }

  renderField({
    input, meta: { touched, error }, type,
  }) {
    const { disabled, value } = this.props;

    const validationState = (touched || type === 'hidden') && error ? 'error' : null;

    const stl = { cursor: disabled ? 'not-allowed' : 'pointer', marginBottom: '5px' };

    const statuses = [
      { label: 'Check closed opportunities', value: 'closed' },
      { label: 'Check open opportunities', value: 'open' },
    ];

    return (
      <FormGroup validationState={validationState}>
        {statuses.map((status) => {
          const isActive = indexOf(value, status.value) >= 0;
          const cls = isActive ? '' : 'text-muted';
          const icon = isActive ? 'check-square-o' : 'square-o';
          const iconCls = isActive ? 'text-active' : '';
          return (
            <div
              style={stl}
              key={status.value}
              onClick={() => {
                this.handleClick(input.name, status.value);
              }}
            >
              <Fa className={iconCls} name={icon} /> <span className={cls}>{status.label}</span>
            </div>
          );
        })}
        {(touched || type === 'hidden') && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }

  render() {
    return (
      <Field
        name={this.props.path[0]}
        type="hidden"
        component={this.renderField}
      />
    )
  }
}

OpportunityStatus.propTypes = {
  path: PropTypes.arrayOf(PropTypes.string).isRequired,
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  editable: PropTypes.bool,
};
OpportunityStatus.defaultProps = {
  disabled: false,
  editable: true,
  onChange: () => {},
};
export default masterField(OpportunityStatus);
